import './modal.scss';

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Wrapper = forwardRef((props, ref) => {
  const className = classNames({
    modal: true,
    show: props.visible,
    [props.effect]: props.effect,
    [props.className]: props.className,
  });

  return (
    <div ref={ref} className={className} role="dialog">
      {props.children}
    </div>
  );
});

Wrapper.propTypes = {
  effect: PropTypes.string,
  visible: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
};

Wrapper.defaultProps = {
  effect: '',
  visible: false,
};

const Backdrop = forwardRef((props, ref) => {
  const className = classNames({
    'modal-backdrop': props.visible,
    show: props.visible,
    [props.effect]: props.effect,
    [props.className]: props.className,
  });

  return (
    <div ref={ref} className={className} role="dialog">
      {props.children}
    </div>
  );
});

Backdrop.propTypes = {
  effect: PropTypes.string,
  visible: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
};

Backdrop.defaultProps = {
  effect: 'fade',
  visible: false,
};

const Dialog = forwardRef((props, ref) => {
  const className = classNames({
    'modal-dialog': true,
    [props.className]: props.className,
  });

  return (
    <div ref={ref} className={className} role="document">
      {props.children}
    </div>
  );
});

Dialog.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

const Content = forwardRef((props, ref) => {
  const className = classNames({
    'modal-content': true,
  });

  return (
    <div ref={ref} className={className}>
      {props.children}
    </div>
  );
});

Content.propTypes = {
  children: PropTypes.node,
};

const Header = forwardRef((props, ref) => {
  const className = classNames({
    'modal-header': true,
  });

  return (
    <div ref={ref} className={className}>
      {props.children}
    </div>
  );
});

Header.propTypes = {
  children: PropTypes.node,
};

const Title = forwardRef((props, ref) => {
  const className = classNames({
    'modal-title': true,
  });

  return (
    <h5 ref={ref} className={className}>
      {props.children}
    </h5>
  );
});

Title.propTypes = {
  children: PropTypes.node,
};

const Body = forwardRef((props, ref) => {
  const className = classNames({
    'modal-body': true,
  });

  return (
    <div ref={ref} className={className}>
      {props.children}
    </div>
  );
});

Body.propTypes = {
  children: PropTypes.node,
};

const Footer = forwardRef((props, ref) => {
  const className = classNames({
    'modal-footer': true,
    [props.className]: props.className,
  });

  return (
    <div ref={ref} className={className}>
      {props.children}
    </div>
  );
});

Footer.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

const Modal = { Wrapper, Dialog, Content, Header, Title, Body, Footer, Backdrop };

export default Modal;
